/**
 * Interpolates a given value using Lagrange's Interpolation
 * through a set of pre-defined known points.
 * @param {Number} x - The value to interpolate
 * @param {Array[Array[2]]} points [[x1,y1], [x2,y2], ...] - Interpolation points, distinct Xn
 * @param {Number} order - Lagrange curve order
 * @returns {Number} - Interpolated value f(x)
 */
export function laginter(x, points, order) {
    if(x === undefined || points === undefined){
        throw "laginter(): one or more required parameters was not defined";
    }

    if(order === undefined){
        order = points.length-1;
    }

    if(points.length<=order || order<1){
        throw `laginter(): cannot interpolate over ${points.length} with the order of ${order}.`;
    }

    let ret = 0;
    for (let term_id = 0; term_id <= order; term_id++) {
        let nm = 1;
        let dn = 1;
        for (let subpart_id = 0; subpart_id <= order; subpart_id++) {
            if(term_id === subpart_id){
                continue
            }
            nm *= x-points[subpart_id][0];
            dn *= points[term_id][0] - points[subpart_id][0];
        }
        ret+= nm/dn*points[term_id][1];
    }
    return ret
}

export function remap(input, from_min, from_max, to_min, to_max, clamp = true) {
    let perc = (input-from_min)/(from_max-from_min)
    if(clamp){
        perc = (perc<0 || perc>1)?(perc<0?0:1):perc
    }
    return (to_max-to_min)*perc+to_min
}

/**
 * Returns a clamped verstion of an input vector
 * using supplied min and max values
 * @param {Array} vector - 1D array of vector-values
 * @param {Number} min - Acceptable min
 * @param {Number} max - Acceptable max
 * @returns {Array} new clamped vector
 */
export function clampVector(vector, min, max) {
    let nv = [];
    for (const vv of vector) {
        nv.push(
            (vv<=max && vv>=min?vv:(vv>max?max:min))
        )
    }
    return nv
}